import { CheckOutlined } from '@ant-design/icons'

import { getMissingSkuReportState } from '../../lib/stockImportsMissingSku'
import type { StockImportLogModel } from '../../types/stockImports.types'
import cn from './MissingSkuReportMark.module.scss'

interface MissingSkuReportMarkProps {
  log: Pick<StockImportLogModel, 'hasMissingSkuData' | 'missingRows'>
}

function MissingSkuReportMark({ log }: MissingSkuReportMarkProps) {
  const state = getMissingSkuReportState(log)
  if (state === 'available') {
    return <CheckOutlined className={cn.available} aria-label="Отчёт есть" />
  }
  if (state === 'deleted') return <span className={cn.deleted}>удалён</span>
  return null
}

export default MissingSkuReportMark
